import type { ReturnExchangeSummary } from '@vastra/types';

/** Human-readable fulfillment + return/exchange timeline (sorted by time). */
export function orderMilestoneRows(order: {
  createdAt: string;
  confirmedAt?: string;
  processingAt?: string;
  shippedAt?: string;
  deliveredAt?: string;
  cancelledAt?: string;
  returnedAt?: string;
  failedAt?: string;
  returnExchangeSummaries?: ReturnExchangeSummary[];
}): { label: string; at: string }[] {
  const rows: { label: string; at: string }[] = [{ label: 'Order placed', at: order.createdAt }];
  if (order.confirmedAt) rows.push({ label: 'Confirmed', at: order.confirmedAt });
  if (order.processingAt) rows.push({ label: 'Processing', at: order.processingAt });
  if (order.shippedAt) rows.push({ label: 'Shipped', at: order.shippedAt });
  if (order.deliveredAt) rows.push({ label: 'Delivered', at: order.deliveredAt });
  if (order.failedAt) rows.push({ label: 'Failed', at: order.failedAt });
  if (order.cancelledAt) rows.push({ label: 'Cancelled', at: order.cancelledAt });
  if (order.returnedAt) rows.push({ label: 'Returned', at: order.returnedAt });

  for (const s of order.returnExchangeSummaries ?? []) {
    const kind = s.kind === 'exchange' ? 'Exchange' : 'Return';
    rows.push({
      at: s.createdAt,
      label: `${kind} request started`,
    });
    if (s.reviewedAt) {
      const reviewedLabel =
        s.status === 'rejected' ? `${kind} request rejected` : `${kind} request approved`;
      rows.push({ at: s.reviewedAt, label: reviewedLabel });
    }
    const processedAt =
      s.processedAt ?? (s.status === 'processed' && s.updatedAt ? s.updatedAt : undefined);
    if (processedAt) {
      rows.push({
        at: processedAt,
        label:
          s.kind === 'return'
            ? 'Refund processed'
            : s.exchangeReplacementOrderId
              ? 'Replacement order created'
              : 'Exchange completed',
      });
    }
  }

  rows.sort((a, b) => new Date(a.at).getTime() - new Date(b.at).getTime());
  return rows;
}
